import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../../services/tools/helpers.service';
import { NominasService } from '../../../../../services/creditos/nominas.service';

@Component({
  selector: 'nomina-capacidad-pago',
  templateUrl: './capacidad-pago.component.html',
  styleUrls: ['./capacidad-pago.component.scss']
})
export class NominaCapacidadPagoComponent implements OnInit {

    @Input() public idCreditos : number = null;
    @Input() public isCompleted : boolean = false;
    @Input() public isEditable: boolean = false;

    //Cliente form
    public nomina : any = {};
    public errors : any = {};
    private isInitialized : boolean = false;
    //Porcentajes
    public porcentajePension: number = null;
    public porcentajeInfonabit: number = null;
    public porcentajeImss: number = null;
    public porcentajeFonacot: number = null;
    public porcentajeProfinmex: number = null;
    public porcentajeOtros: number = null;
    public porcentajeDeducciones: number = null;
    public porcentajeSaldo: number = null;

    constructor(
      private helperService: HelpersService,
      private nominasService: NominasService
    ){
    }

    ngOnInit() {
    }

    public loadComponent(){
      if(!this.isInitialized){
        this.getCredito(this.idCreditos);
        this.isInitialized = true;
      }
    }

    private getCredito(idCreditos : number){
        //TODO: Manejar cuando el id no retorna un crédito valido
        this.nominasService.get(idCreditos).subscribe(
            (response)=>
            {
            const result = response.json().content;
            this.nomina = result.nomina;
            //Setup porcentajes y totales
            this.setPorcentajesAndTotales();
            
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    /**
     * Copie algunas funciones que se utilizan en el simulador para calcular los percentajes y totales
     */
    private setPorcentajesAndTotales(){
        const sueldo_bruto = this.nomina.sueldo_bruto;
        this.porcentajePension = this.calculatePorcentajeDeduccion(this.nomina.pension, sueldo_bruto);
        this.porcentajeInfonabit = this.calculatePorcentajeDeduccion(this.nomina.infonavit, sueldo_bruto);
        this.porcentajeImss = this.calculatePorcentajeDeduccion(this.nomina.imss, sueldo_bruto); 
        this.porcentajeFonacot = this.calculatePorcentajeDeduccion(this.nomina.fonacot, sueldo_bruto); 
        this.porcentajeProfinmex = this.calculatePorcentajeDeduccion(this.nomina.profimex, sueldo_bruto); 
        this.porcentajeOtros = this.calculatePorcentajeDeduccion(this.nomina.otros, sueldo_bruto);  

        //Actualizar el valor de los montos totales y sus porcentajes
        //El nivel del endeudamiento es del 35%
        this.nomina.totalEndeudamiento = (this.nomina.sueldo_bruto * 35) /100;
        //Deducciones
        this.nomina.totalDeducciones = this.calculateTotalDeducciones();
        this.porcentajeDeducciones = this.calculatePorcentajeDeduccion(this.nomina.totalDeducciones, sueldo_bruto);
        //Saldo
        this.nomina.totalSaldo = this.nomina.totalEndeudamiento - (this.nomina.totalDeducciones ? this.nomina.totalDeducciones : 0);
        this.porcentajeSaldo = this.calculatePorcentajeDeduccion(this.nomina.totalSaldo, sueldo_bruto);
    }

    private calculateTotalDeducciones(){
        let totalDeducciones = 0;

        totalDeducciones += Number(this.nomina.pension ? this.nomina.pension : 0);
        totalDeducciones += Number(this.nomina.infonavit ? this.nomina.infonavit : 0);
        totalDeducciones += Number(this.nomina.imss ? this.nomina.imss : 0);
        totalDeducciones += Number(this.nomina.fonacot ? this.nomina.fonacot : 0);
        totalDeducciones += Number(this.nomina.profimex ? this.nomina.profimex : 0);
        totalDeducciones += Number(this.nomina.otros ? this.nomina.otros : 0);

        return totalDeducciones;
    }

    private calculatePorcentajeDeduccion(deduccion: number, sueldo_bruto: number){
        return deduccion ? ((deduccion * 100) / sueldo_bruto) : null;
    }
}


// WEBPACK FOOTER //
// ./src/app/creditos/nomina/detalles/components/capacidad-pago/capacidad-pago.component.ts